import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, PRICE, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
export function FinalCTA() {
  return <section className="border-t-4 border-tech bg-white py-5 sm:py-7" data-id="element-44" data-mp="c83pjkbwtm5j">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-45" data-mp="84e24y6z1am3">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-46" data-mp="m4ykjt8z54f2">
          UNE DERNIÈRE <span className="text-tech-dark" data-id="element-47" data-mp="h5vdk39foo4g">QUESTION</span>
        </h2>
        <div className="mx-auto mt-1.5 max-w-3xl space-y-1 text-center text-sm leading-snug text-steel sm:text-base" data-id="element-48" data-mp="h5loqj04kn0c">
          <p data-id="element-49" data-mp="vwkrvei6yjcj">Combien de fois un apport a-t-il été décidé en espérant que le symptôme disparaisse…</p>
          <p data-id="element-50" data-mp="qy17hij8xfma">
            <strong className="font-semibold text-navy" data-id="element-51" data-mp="14v6js09jzapz">
              sans avoir vraiment confirmé la cause par une observation méthodique et une analyse ?
            </strong>
          </p>
          <p data-id="element-52" data-mp="2c4ob8wnbx767">
            Vous pouvez continuer à chercher dans des cours, des forums et des notes dispersées.
            Ou ouvrir un seul système professionnel organisé.
          </p>
          <p data-id="element-53" data-mp="2h5ko3zpns3nr">
            <strong className="font-semibold text-navy" data-id="element-54" data-mp="2m2udjfd1sfbl">
              Observer. Comparer. Analyser. Puis agir.
            </strong>
          </p>
        </div>

        <MockupImage className="mt-2" data-id="element-55" data-mp="2r38k0sz03h7i" />

        <div className="mt-2 text-center" data-id="element-56" data-mp="2v3sfls3xecrj">
          <p className="font-heading text-xl font-extrabold uppercase leading-tight text-navy sm:text-3xl" data-id="element-57" data-mp="2v2r4xoqtnsac">
            🌿 {PRODUCT}
          </p>
          <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-steel sm:text-base" data-id="element-58" data-mp="34tbyuyvjw8mx">
            {PRODUCT_TAGLINE}
          </p>
          <p className="mt-1 font-display text-2xs font-bold uppercase tracking-wide text-tech-dark sm:text-sm" data-id="element-59" data-mp="39u9fv84tqwmu">
            Fondamentaux • Carences • Sol & pH • Diagnostic • Cultures • Plan d’action
          </p>
        </div>

        <div className="mt-3 flex flex-col items-center" data-id="element-60" data-mp="1jntsjwpbo3ze">
          <p className="mb-2 text-center font-display text-base font-extrabold uppercase leading-tight text-navy sm:text-xl" data-id="element-61" data-mp="1jm8xm5z3ij10">
            🔥 OBTENEZ LE SYSTÈME COMPLET AUJOURD’HUI — <span className="text-tech-dark" data-id="element-62" data-mp="1shgjn9il4j29">{PRICE}</span>
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-63" data-mp="1npor4tfvc39h">🌿 OUI ! JE VEUX {PRODUCT}</CTAButton>
          <TrustLine items={['Accès immédiat • Livraison numérique', '🛡️ Garantie de 7 jours']} data-id="element-64" data-mp="22ekwgiqjj26e" />
        </div>
      </div>
    </section>;
}